import type { Maybe } from '@adornis/base/utilTypes.js';
import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { EmailAttachments, EmailType, EmailVars } from '@ils/mails/emailEnums.js';
import type { ExamType } from '@ils/static/enums.js';
import { getSalutation } from '@legacy-db/utils.js';
import { html } from 'lit';

export const CertificateMail = defineMailTemplate(EmailType.CERTIFICATE, {
  displayName: EmailType.CERTIFICATE,
  defaultTemplate: {
    subject: 'FaMed - Fachsprachenprüfung Medizin - Urkunde',
    content: `
<p>Sehr geehrte {{${EmailVars.SALUTATION}}} {{${EmailVars.LASTNAME}}},</p>
<p> Ihre Urkunde zum Nachweis der bestandenen Prüfung finden Sie hier:</p>
<p><a href="{{${EmailVars.CERTIFICATE_LINK}}}">Urkunde</a></p>
<p>Wir wünschen Ihnen alles Gute bei der Vorbereitung auf die Fachsprachprüfung Medizin.</p>
<p>Ihr FaMed-Team</p>
`,
    footer: '',
  },
  variables: [EmailVars.SALUTATION, EmailVars.FIRSTNAME, EmailVars.LASTNAME, EmailVars.CERTIFICATE_LINK],
  attachments: [EmailAttachments.INFO_PDF],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Prüfling<br />
      - service email
    </p>
    <p>
      Wann:<br />
      - per Knopf in Bewertungsübersicht an alle Prüflinge welche zu diesem Zeitpunkt bereits als "Bestanden" gelten
    </p>
  `,
  getMailData: (
    user: { ecommerce?: Maybe<{ firstName: string; lastName: string }>; username: string; email: string },
    certificateLink: string,
    scope: ExamType,
  ) => {
    return {
      data: {
        [EmailVars.SALUTATION]: getSalutation(user),
        [EmailVars.FIRSTNAME]: user.ecommerce?.firstName ?? '---',
        [EmailVars.LASTNAME]: user.ecommerce?.lastName ?? user.username,
        [EmailVars.CERTIFICATE_LINK]: certificateLink,
      },
      scope,
    };
  },
});
